export default "__VITE_ASSET__BqLlH0Q___"